{
    "smartTasks": {
        "tourLabel": "Tareas inteligentes",
        "learn": "Aprenda a generar, reescribir y traducir texto con Cephable.",
        "generate": {
            "openTool": {
                "title": "Abrir la herramienta Generar texto",
                "description": "En el panel de Cephable, haga clic en la zanahoria junto a Tareas inteligentes y seleccione Generar texto."
            },
            "enterPrompt": {
                "title": "Ingresar mensaje",
                "description": "En el cuadro de solicitud, escribe: Crea un juego de palabras de una sola oración que sea creíble."
            },
            "clickGenerate": {
                "title": "Haga clic en Generar",
                "description": "Haz clic en el botón Generar. Observa cómo aparece el texto en tiempo real."
            },
            "focusApp": {
                "title": "Concéntrese en la aplicación",
                "description": "Asegúrate de estar enfocado en la aplicación donde quieres que aparezca el texto generado. Podrás generar texto sin problemas en esa ubicación al hacer clic en \"Generar\"."
            }
        },
        "rewrite": {
            "welcome": {
                "title": "Bienvenido a Rewrite",
                "description": "Reformule el contenido rápidamente con texto resaltado o pegado."
            },
            "highlightToggle": {
                "title": "Usar texto resaltado",
                "description": "Asegúrese de que “Usar texto resaltado” esté seleccionado (predeterminado)."
            },
            "highlightText": {
                "title": "Resaltar texto para reescribir",
                "description": "Destacado: Un pulpo puede controlar cada brazo independientemente."
            },
            "enterInstructions": {
                "title": "Introduzca instrucciones de reescritura",
                "description": "Tipo: En estilo inglés antiguo."
            },
            "clickGenerate": {
                "title": "Haga clic en Generar",
                "description": "El texto resaltado será reescrito en base a tu entrada."
            },
            "pasteMode": {
                "title": "Usar Pegar texto",
                "description": "Pegue el original y reescriba la instrucción. Haga clic en \"Generar\". Haga clic en \"Borrar\" para restablecer."
            },
            "openTool": {
                "title": "Abrir la herramienta Reescribir texto",
                "description": "En el panel de Cephable, haga clic en la zanahoria junto a Tareas inteligentes y seleccione Reescribir texto."
            },
            "focusApp": {
                "title": "Concéntrese en la aplicación",
                "description": "Asegúrate de estar enfocado en la aplicación donde quieres que aparezca el texto reescrito. Podrás generar texto sin problemas en esa ubicación al hacer clic en \"Generar\"."
            }
        },
        "translate": {
            "welcome": {
                "title": "Bienvenido a Translate",
                "description": "Traducir el texto resaltado o pegado a otro idioma."
            },
            "highlightToggle": {
                "title": "Usar texto resaltado",
                "description": "Asegúrese de que la opción “Usar texto resaltado” esté seleccionada."
            },
            "highlightText": {
                "title": "Resaltar texto para traducir",
                "description": "Destacado: Un pulpo puede controlar cada brazo independientemente."
            },
            "enterLanguage": {
                "title": "Introduzca el idioma de destino",
                "description": "Tipo: Portugués."
            },
            "clickGenerate": {
                "title": "Haga clic en Generar",
                "description": "La traducción se escribirá en su aplicación cuando usted coloque el cursor."
            },
            "pasteMode": {
                "title": "Usar Pegar texto",
                "description": "Pegue el texto y el idioma. Haga clic en Generar. Haga clic en Borrar para restablecer."
            },
            "openTool": {
                "title": "Abrir la herramienta Traducir texto",
                "description": "En el panel de Cephable, haga clic en la zanahoria junto a Tareas inteligentes y seleccione Traducir texto."
            }
        },
        "rowDescription": "Las tareas inteligentes son las diferentes tareas que la IA de Cephable puede realizar por ti. Estas tareas, impulsadas por la IA del dispositivo, permiten crear texto, resumir, reescribir, traducir y mucho más."
    },
    "overview": {
        "title": "Descripción general",
        "description": "Cephable es tu IA personal: diseñada para acciones rápidas, comandos de voz, generación de contenido y automatización inteligente en todas tus herramientas. Controles preconfigurados. Sin procesamiento en la nube. Solo productividad que se mueve contigo."
    },
    "customControls": {
        "tourLabel": "Controles globales y de dispositivos siempre disponibles",
        "rowDescription": "Los controles globales y del dispositivo siempre están disponibles si el micrófono está activado, independientemente de la aplicación que uses. Puedes usar estos controles para interactuar con tu dispositivo sin tener que crear nuevos controles para la aplicación. Incluyen comandos útiles como intercambiar controles o aplicaciones, generar texto, pausar el micrófono y mucho más."
    },
    "profile": {
        "tourLabel": "Controles de la aplicación",
        "learn": "Aprenda a configurar los controles y preferencias de su aplicación en Cephable.",
        "rowDescription": "Los controles de la aplicación son conjuntos de controles configurados que puedes usar para hacer cosas. ¿Quieres decir \"Siguiente diapositiva\" para ir a la siguiente diapositiva de tu presentación? ¿O usar el movimiento de la cabeza para mover el cursor y los controles de voz para editar accesos directos? Puedes hacerlo con los controles de la aplicación. La fila de controles muestra todos los controles disponibles para tu aplicación actual.",
        "check": {
            "title": "Verifique sus controles disponibles.",
            "description": "Los controles de la aplicación están disponibles para cada aplicación que uses. Aquí puedes ver los controles disponibles para la aplicación que estás usando. Prueba otro comando para ver cómo funciona. PERO, asegúrate de estar enfocado en la aplicación que quieres controlar."
        }
    },
    "dictation": {
        "tourLabel": "Dictado",
        "learn": "Aprenda a utilizar el modo de dictado para convertir su voz en texto con manos libres.",
        "welcome": {
            "title": "Dictado",
            "description": "El dictado te permite hablar con naturalidad y escribir tus palabras mientras hablas. Es como tener un asistente personal que escribe todo lo que dices."
        },
        "microphone": {
            "title": "Enciende tu micrófono",
            "description": "Primero, activa el micrófono. Haz clic en el interruptor de micrófono en el panel de Cephable."
        },
        "activate": {
            "title": "Iniciar el modo de dictado",
            "description": "La voz se inicia en modo comando. Para iniciar el dictado, diga \"Iniciar dictado\" o haga clic en el botón Dictado. Activemos el modo de dictado."
        },
        "focus": {
            "title": "Centrarse en un campo de texto o documento",
            "description": "El dictado funciona mejor cuando te centras en un campo de texto o documento. Haz clic en el campo de texto o documento donde quieras dictar."
        },
        "speaking": {
            "title": "Empieza a hablar",
            "description": "Ahora puedes empezar a hablar. Todo lo que digas se escribirá en el campo de texto o documento que hayas seleccionado. Intenta decir algo como \"Hola, esta es una prueba del modo de dictado\"."
        },
        "pauseResume": {
            "title": "Pausa del dictado",
            "description": "¿Necesitas un descanso sin desactivar el dictado? Simplemente di \"Pausar dictado\". Puedes reanudarlo en cualquier momento con \"Iniciar dictado\". Puedes personalizarlo aún más con los controles globales y del dispositivo siempre activos."
        },
        "stop": {
            "title": "Detener el dictado",
            "description": "¿Necesitas volver a los controles de tu aplicación? Simplemente di \"Detener dictado\". Esto detendrá el modo de dictado y te permitirá volver al modo comando. Puedes reanudarlo en cualquier momento con \"Iniciar dictado\"."
        },
        "complete": {
            "description": "¡Listo! Ahora puedes dictar, pausar, reanudar y alternar entre los modos de dictado y comando. El dictado es una herramienta potente para escribir sin usar las manos. Úsalo para escribir correos electrónicos, documentos o cualquier otra cosa que necesites escribir en voz alta."
        }
    },
    "camera": {
        "tourLabel": "Controles de la cámara",
        "rowDescription": "Los controles de la cámara te permiten usar tu cara y cuerpo para controlar tu dispositivo. Puedes usar diferentes expresiones faciales y movimientos de cabeza para controlarlo. Con el micrófono activado, puedes usar comandos de voz para iniciar y detener la cámara, y cambiar de cámara.",
        "learn": "Aprenda a utilizar los controles de la cámara para navegar e interactuar con su dispositivo con manos libres.",
        "welcome": {
            "title": "Controles de la cámara",
            "description": "Los controles de la cámara te permiten usar tu cara y cuerpo para controlar tu dispositivo. Puedes usar diferentes expresiones faciales, movimientos de cabeza y comandos de voz para navegar e interactuar con tu dispositivo sin usar las manos."
        },
        "start": {
            "title": "Iniciar controles de la cámara",
            "description": "Para comenzar a usar los controles de la cámara si está usando la voz, diga \"Iniciar controles de la cámara\" o haga clic en el botón Controles de la cámara."
        }
    },
    "microphone": {
        "tourLabel": "Controles de voz",
        "learn": "Aprenda cómo puede usar su voz para controlar cualquier aplicación y usar el dictado para escribir lo que dice.",
        "description": "Los controles de voz de Cephable te permiten usar tu voz para controlar tu dispositivo. ¿Quieres guardar un documento? Solo di \"guardar\". ¿Quieres pausar la música? Solo di \"pausar\". La voz también te permite usar el dictado para escribir lo que dices.",
        "rowDescription": "Cuando el micrófono esté apagado, no escucharemos tus comandos de voz, pero si lo enciendes, podrás usar comandos globales para pausar, iniciar y más. Vamos a encenderlo.",
        "start": {
            "title": "Iniciar controles de voz",
            "description": "Para empezar a usar los controles de voz, haz clic en el interruptor del micrófono en el panel de Cephable. Esto activará el micrófono y comenzará a escuchar comandos."
        },
        "tryOpen": {
            "title": "Prueba a decir «Abrir Spotify» o «Abrir Word».",
            "description": "\"Abrir\" es un comando global que abrirá la aplicación que especifiques y le asignará el foco. Si tienes habilitado el cambio automático de controles, también cambiará a los controles de la aplicación que mejor se adapten a la que estés usando."
        },
        "finishedCommands": {
            "title": "¡Excelente! Has aprendido lo básico de los controles de voz.",
            "description": "Siempre puedes volver a visitar el recorrido desde la página de soporte. El siguiente paso es aprender sobre Dictado. Puedes comenzar el recorrido desde la página de soporte."
        }
    },
    "publicProfiles": {
        "tourLabel": "Personalizar los controles de la aplicación"
    },
    "tour": {
        "title": "Bienvenido a Cephable",
        "description": "Cephable es una potente herramienta que te permite controlar tu ordenador con la voz, la cámara y otras entradas. Este tutorial te guiará por las funciones clave y cómo usarlas eficazmente.",
        "startTour": "Iniciar Tour",
        "finishTour": "Finalizar el recorrido",
        "statusDialog": "Por favor consulte el panel para obtener más información.",
        "step": "Paso {{paso}} de {{total}}",
        "next": "Próximo",
        "previous": "Anterior",
        "endTour": "Fin del recorrido",
        "nextTourLabel": "Siguiente: {{nextStepTitle}}",
        "skipTour": "Saltar el recorrido",
        "steps": {
            "welcome": {
                "title": "Bienvenido a Cephable",
                "description": "Este recorrido te guiará por las principales funciones de Cephable. ¡Comencemos!"
            },
            "inputs": {
                "title": "Descripción general de las entradas",
                "description": "Cephable admite varios métodos de entrada, como comandos de voz, controles de cámara y más. Puedes personalizarlos en la configuración."
            },
            "appControls": {
                "title": "Controles de la aplicación",
                "description": "Crea controles de app para asignar tus entradas a acciones específicas en tus aplicaciones. Esto te permite controlar apps con gestos, comandos de voz y más."
            },
            "settings": {
                "title": "Ajustes",
                "description": "Accede a la configuración para configurar tus entradas, controles de la app y otras preferencias. También puedes administrar tu cuenta y la configuración de idioma aquí."
            },
            "intelligentTasks": {
                "title": "Tareas inteligentes",
                "description": "Utilice tareas inteligentes para generar texto, resumir contenido, reescribir texto, traducir idiomas y más utilizando funciones impulsadas por IA."
            },
            "cameraControls": {
                "title": "Controles de la cámara",
                "description": "Habilite los controles de la cámara para utilizar expresiones faciales y movimientos de la cabeza como métodos de entrada para controlar su computadora."
            },
            "voiceControls": {
                "title": "Controles de voz",
                "description": "Usa comandos de voz para controlar tu computadora sin usar las manos. Puedes dictar texto, dar comandos e interactuar con aplicaciones usando la voz."
            }
        }
    },
    "onboarding": {
        "demoPlaceholder": "Este es el texto de demostración del marcador de posición. Con las indicaciones anteriores, puede controlar el estilo de este texto.",
        "exit": "Configuración de salida",
        "overview": "Descripción general",
        "learn": "Conozca las características de Cephable y cómo usarlas.",
        "start": "Parece que apenas estás empezando. Aquí tienes algunas áreas que te ayudarán en el proceso.",
        "startTour": "Empezar",
        "dashboard": {
            "title": "Panel de Cephable",
            "description": "El Panel de Control de Cephable es tu centro de control para administrar tu dispositivo, los controles de las apps y la configuración. Desde aquí, puedes personalizar tu experiencia, ver los comandos activos y acceder a todas las funciones de Cephable."
        },
        "step1": {
            "title": "Bienvenido a Cephable",
            "description": "Cephable es tu IA personal: diseñada para acciones rápidas, comandos de voz, generación de contenido y automatización inteligente en todas tus herramientas. Controles preconfigurados. Sin procesamiento en la nube. Solo productividad que se mueve contigo.",
            "inputs": "¿Qué son las entradas?",
            "inputDescription": "Los controles de entrada son los métodos para operar su dispositivo, ampliando las capacidades de su computadora más allá del ratón y el teclado tradicionales. Estos métodos incluyen comandos de voz, movimientos de cabeza, expresiones faciales y periféricos adicionales.",
            "profiles": "¿Qué son los controles de aplicaciones?",
            "profileDescription": "Los controles de la aplicación te permiten conectarte y comunicarte con tu computadora de maneras únicas al combinar controles de entrada y salida. Con los controles de la aplicación, puedes indicarle a Cephable que realice tareas como guardar un archivo inclinando la cabeza o hacer clic en \"Enviar\" en un correo electrónico con una sonrisa.",
            "action": "Explorar los controles de entrada",
            "secondaryAction": "Saltar a los controles de la aplicación",
            "secondaryActionDescription": "¿Ya conoces los controles de entrada?"
        },
        "finish": {
            "title": "Configuración completada",
            "description": "¡Has usado correctamente tus primeros controles de la app de Cephable! Ahora puedes usar estos y más en tu dispositivo. Están disponibles en tu Panel de Control de Cephable, donde puedes seguir personalizando la configuración de los controles de la app según sea necesario.",
            "continueToApp": "Continuar al panel de Cephable",
            "keepExploring": "Sigue explorando"
        },
        "useCaseSlider": {
            "context": "Me gustaría usar",
            "control": "Para controlar"
        }
    },
    "support": {
        "tourLabel": "¿Listo para aprender más?",
        "description": "Puede visitar nuestro centro de soporte para obtener más información sobre cómo usar Cephable, incluidos más recorridos, guías paso a paso, tutoriales y videos.",
        "cta": "Explorar otros tours"
    },
    "featureFlag": {
        "title": "Es hora de actualizar",
        "description": "La función que intentas usar requiere una licencia diferente. Actualiza para desbloquear esta función y más."
    },
    "replyToSocialMedia": {
        "tourLabel": "Respuestas más rápidas en redes sociales con dictado",
        "learn": "Aprenda a usar el dictado para responder publicaciones en las redes sociales con manos libres.",
        "navigateTo": {
            "title": "Navegar a una publicación en redes sociales",
            "description": "Abre tu navegador web y accede a una red social como LinkedIn o Facebook. Busca una publicación a la que quieras responder."
        },
        "speaking": {
            "title": "Empieza a hablar",
            "description": "Ahora puedes empezar a hablar. Todo lo que digas se escribirá en el campo de texto o documento que hayas seleccionado. Intenta decir algo como \"¡Felicidades! ¡Me alegro mucho por ti!\". Asegúrate de que el cursor esté seleccionado en un campo de texto o cuadro de comentarios."
        },
        "complete": {
            "description": "¡Listo! Ahora puedes usar dictar, pausar, reanudar y alternar entre dictado y comandos para responder a publicaciones en redes sociales sin usar las manos. Dictado es una herramienta potente para escribir sin usar las manos. Úsala para escribir correos electrónicos, documentos o cualquier otra cosa que necesites escribir en voz alta."
        }
    },
    "hotkeys": {
        "tourLabel": "Botones de acción rápida",
        "learn": "Aprenda a configurar botones de acción rápida para asignar múltiples acciones a un solo botón.",
        "rowDescription": "Los botones de acción rápida te permiten realizar varias acciones con un solo comando. Por ejemplo, puedes crear un botón que abra tu app de música favorita y comience a reproducir una lista de reproducción específica.",
        "check": {
            "title": "Consulta tus acciones rápidas disponibles.",
            "description": "Hay botones de acción rápida disponibles para cada aplicación que uses. Aquí puedes ver los botones disponibles para la aplicación que estás usando. Prueba otro comando para ver cómo funciona. PERO, asegúrate de estar enfocado en la aplicación que quieres controlar."
        }
    },
    "controllingBackgroundMusic": {
        "tourLabel": "Gestiona la música de fondo sin interrumpir tu flujo",
        "learn": "Aprenda a utilizar controles de voz y acciones rápidas para controlar su música con manos libres, mientras se concentra en su tarea actual.",
        "tryOpen": {
            "title": "Prueba a decir «Abrir Spotify» o «Abrir Apple Music»"
        },
        "play": {
            "title": "Prueba a decir \"Reproducir\" para empezar a reproducir música.",
            "description": "Asegúrate de que tu micrófono esté activado y di \"Reproducir\". Esto iniciará la reproducción de música en la app de música que hayas elegido. Esto también funciona con cualquier otra app multimedia."
        },
        "newPlaylist": {
            "title": "Crear una nueva lista de reproducción",
            "description": "Asegúrate de que tu micrófono esté activado y di \"Nueva lista de reproducción\". Esto iniciará el proceso de creación de una nueva lista de reproducción en la app de música que hayas elegido."
        },
        "finishedCommands": {
            "title": "¡Excelente trabajo! Has aprendido a controlar tu música con las manos libres.",
            "description": "Ya sabes cómo usar comandos de voz y acciones rápidas para reproducir, pausar, saltar pistas y ajustar el volumen en tus apps de música favoritas. Explora más comandos o personaliza tus propias acciones rápidas para un control de música aún más fluido."
        }
    },
    "editingVideos": {
        "tourLabel": "Concéntrese en la historia, no en los tediosos clics de la edición de video",
        "learn": "Aprenda a usar controles de voz y acciones rápidas para editar videos más rápido y eliminar la carga cognitiva de recordar qué botones hacer clic mientras edita.",
        "tryOpen": {
            "title": "Prueba a decir «Abrir iMovie» o «Abrir DaVinci Resolve»"
        },
        "play": {
            "title": "Prueba a decir \"Reproducir\" para comenzar a reproducir tu vídeo.",
            "description": "Asegúrate de que tu micrófono esté activado y di \"Reproducir\". Esto iniciará la reproducción del video en la aplicación de edición de video que hayas elegido."
        },
        "stop": {
            "title": "Detener la reproducción del vídeo",
            "description": "Asegúrate de que tu micrófono esté activado y di \"Detener\". Esto detendrá la reproducción del video en la aplicación de edición de video que hayas elegido."
        },
        "finishedCommands": {
            "title": "¡Excelente trabajo! Has aprendido a controlar la edición de video sin usar las manos.",
            "description": "Ya sabes cómo usar comandos de voz y acciones rápidas para reproducir, pausar, saltar pistas y ajustar el volumen en tus apps de edición de video favoritas. Explora más comandos o personaliza tus propias acciones rápidas para un control de video aún más fluido."
        }
    },
    "vibeCoding": {
        "tourLabel": "Idear, prototipar e iterar más rápido con Dictado",
        "learn": "Aprenda a utilizar el dictado y la generación de texto impulsada por IA para vibrar el código, crear prototipos e iterar ideas.",
        "navigateTo": {
            "title": "Navegar a un editor de código Vibe",
            "description": "Abra su navegador web y acceda al editor de código de Vibe. Algunos ejemplos son Vercel V0, GitHub Copilot en VS Code, Base 44 y Lovable."
        },
        "focus": {
            "title": "Haga clic en Nuevo chat o en Enfocar un cuadro de texto",
            "description": "El dictado funciona mejor cuando te concentras en un campo de texto o documento. Haz clic en el cuadro de comentarios o en el hilo de respuestas donde quieras dictar. Luego, empieza a hablar."
        },
        "speaking": {
            "title": "Empieza a hablar",
            "description": "Ahora puedes empezar a hablar. Todo lo que digas se escribirá en el campo de texto o documento que hayas seleccionado. Intenta indicar tus requisitos técnicos y la función del código. Asegúrate de que el cursor esté seleccionado en un campo de texto o cuadro de comentarios."
        },
        "rewriteIntro": {
            "title": "Reescribir código con instrucciones",
            "description": "También puedes usar Tareas Inteligentes como Reescribir para modificar el código existente. Esta tarea se basa en la IA del dispositivo, lo que significa que funciona sin conexión a internet y se ejecuta desde tu dispositivo."
        },
        "highlightText": {
            "title": "Resaltar texto para reescribir",
            "description": "Resalte el código que desea reescribir."
        },
        "enterInstructions": {
            "title": "Introduzca instrucciones de reescritura",
            "description": "Escriba las instrucciones de reescritura de código. Especifique el lenguaje de programación, el estilo o cualquier cambio específico que desee."
        },
        "complete": {
            "description": "¡Listo! Ahora puedes dictar, pausar, reanudar e iterar en el código. Continúa explorando más casos de uso con Dictado y Tareas Inteligentes, u otras funciones para optimizar tu flujo de trabajo."
        }
    },
    "documentCode": {
        "tourLabel": "Documentación de código rápida y segura con generación de texto de IA en el dispositivo",
        "learn": "Aprenda a utilizar la reescritura impulsada por IA para documentar el código mientras permanece en la misma aplicación y mantiene sus datos seguros.",
        "rewriteIntro": {
            "title": "Escribir documentación de código",
            "description": "Puedes usar Cephable Intelligent Rewrite para escribir documentación de código en un documento o aplicación independiente. Rewrite forma parte de las tareas de IA en el dispositivo, incluyendo la generación y traducción sin conexión."
        },
        "focusApp": {
            "title": "Concéntrese en su código",
            "description": "Abra su IDE y concéntrese en el código que desea documentar."
        },
        "newFile": {
            "title": "Crear un archivo de documentación",
            "description": "Crea un nuevo archivo en tu IDE o abre una aplicación separada donde quieras que aparezca la documentación."
        },
        "highlightText": {
            "title": "Código destacado",
            "description": "Resalte y copie el código que desea documentar."
        },
        "pasteMode": {
            "title": "Haga clic en la pestaña Pegar texto",
            "description": "Utilice el modo pegar para pegar el código original y escribir la documentación en un nuevo archivo."
        },
        "pasteInput": {
            "title": "Pegar código en el documento",
            "description": "Pegue el código que desea documentar en el cuadro de entrada."
        },
        "enterInstructions": {
            "title": "Introduzca instrucciones de formato, estilo y contenido",
            "description": "Escribe las instrucciones de la documentación de codificación. Especifica el tipo de archivo (por ejemplo, Markdown), el estilo o cualquier contenido específico que desees."
        },
        "complete": {
            "description": "Aprendió a usar las Tareas Inteligentes para documentar código de forma rápida y segura. Continúe explorando más casos de uso con Rewrite u otras funciones para optimizar su flujo de trabajo."
        }
    },
    "generateCode": {
        "tourLabel": "Generación de código rápida y segura con generación de texto con IA en el dispositivo",
        "learn": "Aprenda a utilizar la generación impulsada por IA para crear fragmentos de código mientras se mueve entre aplicaciones y mantiene sus datos seguros.",
        "rewriteIntro": {
            "title": "Escribir fragmentos de código",
            "description": "Puedes usar Cephable Intelligent Rewrite para escribir fragmentos de código en tu IDE mientras obtienes los requisitos de otra aplicación. Rewrite forma parte de las tareas de IA en el dispositivo, incluyendo la generación y traducción sin conexión."
        },
        "focusApp": {
            "title": "Concéntrese en el contenido de su ticket",
            "description": "Abra su ticket que especifica los requisitos y concéntrese en el contenido para el que desea generar código."
        },
        "newFile": {
            "title": "Crear un archivo de fragmento de código",
            "description": "Crea un nuevo archivo en tu IDE."
        },
        "highlightText": {
            "title": "Destacar el contenido del ticket",
            "description": "Resalte y copie el contenido para el cual desea generar código."
        },
        "pasteMode": {
            "title": "Haga clic en la pestaña Pegar texto",
            "description": "Utilice el modo pegar para pegar los requisitos del ticket original y escribir fragmentos de código para ellos."
        },
        "pasteInput": {
            "title": "Pegar requisitos para generar código",
            "description": "Pegue los requisitos que desea utilizar para la generación de código en el cuadro de entrada."
        },
        "enterInstructions": {
            "title": "Introducir instrucciones de lenguaje y estilo de programación",
            "description": "Escriba su lenguaje de programación y las instrucciones de estilo. Especifique el lenguaje de programación (por ejemplo, C#), el estilo o cualquier instrucción de codificación específica que tenga."
        },
        "translateIntro": {
            "title": "Traducir fragmentos de código",
            "description": "También puedes usar Cephable Intelligent Translate para convertir fragmentos de código de un lenguaje de programación a otro directamente en tu IDE. Translate forma parte de las tareas de IA en el dispositivo, incluyendo la generación y reescritura sin conexión."
        },
        "copyGeneratedCode": {
            "title": "Copiar el código generado",
            "description": "Después de generar el código utilizando los pasos anteriores, resalte y copie el fragmento de código generado."
        },
        "translatePasteMode": {
            "title": "Haga clic en la pestaña Pegar texto",
            "description": "Utilice el modo pegar para pegar el código original y traducirlo a otro lenguaje de programación."
        },
        "enterProgrammingLanguage": {
            "title": "Introduzca el lenguaje de programación de destino",
            "description": "Escriba el lenguaje de programación al que desea traducir el código (por ejemplo, Python)."
        },
        "pasteCode": {
            "title": "Pegue el código generado en su IDE",
            "description": "Vaya a su IDE y pegue el fragmento de código copiado en el nuevo archivo que creó anteriormente."
        },
        "complete": {
            "description": "Aprendió a usar Tareas Inteligentes para generar y traducir código de forma rápida y segura. Continúe explorando más casos de uso con Generar y Traducir, u otras funciones, para optimizar su flujo de trabajo."
        }
    },
    "requirementDocsFromMeeting": {
        "tourLabel": "De notas a documentos de requisitos del producto en minutos",
        "learn": "Aprenda a utilizar tareas inteligentes de IA para crear documentos estructurados de requisitos de productos a partir de notas de reuniones mientras mantiene sus datos seguros.",
        "rewriteIntro": {
            "title": "Crear documentos de requisitos de producto",
            "description": "Puede usar Cephable Intelligent Rewrite para crear documentos estructurados de requisitos de producto a partir de notas de reuniones. Rewrite forma parte de las tareas de IA en el dispositivo, que incluyen la generación y traducción sin conexión."
        },
        "focusNotes": {
            "title": "Abra sus notas de reunión",
            "description": "Abra sus notas de reunión, transcripciones u otro contenido de texto relacionado con la reunión."
        },
        "highlight": {
            "title": "Resaltar notas de la reunión",
            "description": "Resalte las notas de la reunión que desea utilizar para crear un documento de requisitos del producto."
        },
        "enterInstructions": {
            "title": "Introducir instrucciones sobre la estructura y el contenido del documento",
            "description": "Escriba las instrucciones del documento de requisitos del producto. Especifique la estructura, el estilo o cualquier contenido específico que desee."
        },
        "complete": {
            "description": "Aprendió a usar Tareas Inteligentes para crear documentos de requisitos de producto de forma rápida y segura. Continúe explorando más casos de uso con Rewrite u otras funciones para optimizar su flujo de trabajo."
        }
    },
    "headMouseMovement": {
        "tourLabel": "Configuración de juegos manos libres con ratón de cabeza",
        "learn": "Aprenda a utilizar los movimientos de la cabeza para controlar el cursor del mouse para navegar y hacer clic con precisión.",
        "deviceSettings": {
            "title": "Abrir la configuración del dispositivo",
            "description": "Para habilitar los movimientos de la cabeza del mouse, haga clic en el botón Configuración del dispositivo."
        },
        "cameraSettings": {
            "title": "Abrir la configuración de la cámara",
            "description": "En la configuración del dispositivo, haga clic en Configuración de la cámara para acceder a los controles de la cámara."
        },
        "headMouseSection": {
            "title": "Movimiento de la cabeza para los controles del ratón",
            "description": "Cuando esta opción está activada, algunos de los controles de movimiento de la cabeza se utilizarán para mover el mouse en lugar de los controles de disparo."
        },
        "steadyGlide": {
            "title": "Modo de planeo constante",
            "description": "Activa el modo Deslizamiento constante. Al mover la cabeza más allá de un punto determinado, el cursor se desliza continuamente en esa dirección a una velocidad constante."
        },
        "customization": {
            "title": "Personalizar la configuración del ratón de cabeza",
            "description": "Puedes personalizar la configuración del ratón de cabeza según tus preferencias. Ajusta la velocidad, la sensibilidad y otros parámetros para disfrutar de la mejor experiencia."
        },
        "save": {
            "title": "Guardar la configuración del mouse de cabeza",
            "description": "No olvides guardar la configuración personalizada del mouse de cabeza."
        },
        "transition": {
            "title": "Pasando al panel Cephable",
            "description": "Ahora pasemos al Panel Cephable para probar los movimientos de la cabeza del mouse."
        },
        "playGames": {
            "title": "Juega juegos con Head Mouse",
            "description": "Ahora puedes usar los movimientos de la cabeza para controlar el cursor del ratón mientras juegas. ¡Pruébalo y descubre cómo funciona!"
        }
    },
    "clinicalNoteTaking": {
        "tourLabel": "Dictado y formato conforme a la HIPAA para médicos",
        "learn": "Aprenda a utilizar comandos de voz, dictado inteligente y formato de IA para tomar notas clínicas.",
        "speaking": {
            "title": "Empieza a hablar",
            "description": "Ahora puede empezar a hablar. Todo lo que diga se escribirá en el campo de texto o documento que haya seleccionado. Intente decir algo como: \"El paciente es un hombre de 45 años con antecedentes de hipertensión. El último medicamento recetado no funcionó como se esperaba y le causó una reacción alérgica. Necesitamos buscar medicamentos alternativos y le gustaría una receta de marca genérica\"."
        },
        "rewriteIntro": {
            "title": "Formatear sus notas",
            "description": "Ahora puedes usar Cephable Intelligent Rewrite para formatear tus notas en estilo SOAP. Todo esto se realiza en el dispositivo, lo que significa que tus datos se mantienen privados, seguros y cumplen con la HIPAA."
        },
        "copyText": {
            "title": "Copiar las notas",
            "description": "Después de resaltar sus notas, copie el texto para prepararlo para el formato."
        },
        "pasteMode": {
            "title": "Haga clic en la pestaña Pegar texto",
            "description": "Utilice el modo pegar para pegar las notas originales y formatearlas en estilo SOAP."
        },
        "pasteInput": {
            "title": "Pegar notas en formato",
            "description": "Pegue las notas que desea formatear en el cuadro de entrada."
        },
        "enterInstructions": {
            "title": "Introduzca instrucciones de formato",
            "description": "Puede escribir instrucciones de formato que deberán seguirse en su clínica o sistema de HCE. (Por ejemplo, formato en estilo SOAP con encabezados, viñetas y lenguaje conciso)."
        },
        "navigateToEHR": {
            "title": "Navegue a su sistema EHR",
            "description": "Abra su sistema EHR y navegue hasta la sección donde desea ingresar las notas formateadas."
        },
        "focusTextField": {
            "title": "Centrarse en el campo de texto",
            "description": "Haga clic en el campo de texto donde desea pegar las notas formateadas."
        },
        "complete": {
            "description": "Aprendió a usar comandos de voz y dictado inteligente para documentar notas clínicas, y la reescritura inteligente para formatearlas en estilo SOAP. Continúe explorando más casos de uso con dictado y reescritura, u otras funciones, para optimizar su flujo de trabajo."
        },
        "focus": {
            "title": "Centrarse en un documento",
            "description": "El dictado funciona mejor cuando te concentras en un documento. Abre el documento donde quieras tomar notas clínicas entre sesiones."
        }
    },
    "webBrowsing": {
        "tourLabel": "Planifique viajes, compre en línea y navegue por la web usando la voz",
        "learn": "Aprenda a utilizar comandos de voz para navegar, desplazarse y completar formularios mientras navega por la web con manos libres.",
        "tryOpen": {
            "title": "Prueba a decir «Abrir Chrome» o «Abrir Edge»",
            "description": "Asegúrate de que tu micrófono esté activado y di \"Abrir Chrome\" o \"Abrir Edge\". Esto abrirá el navegador web que hayas elegido. Si tienes activado el cambio automático de controles, también se cambiarán a los controles de la aplicación que mejor se adapten a la que estés usando."
        },
        "search": {
            "title": "Búsqueda",
            "description": "Prueba a decir \"Buscar\" o \"Buscar\". Esto enfocará la barra de búsqueda en tu navegador."
        },
        "quickType": {
            "title": "Escritura rápida",
            "description": "Escritura rápida te permite escribir con la voz sin usar el modo de dictado. Prueba a decir \"Escribe qué tiempo hace hoy\". Esto escribirá tu consulta en la barra de búsqueda."
        },
        "enter": {
            "title": "Presione Enter",
            "description": "Prueba a decir \"Intro\". Esto ejecutará la búsqueda que acabas de escribir."
        },
        "scrollDown": {
            "title": "Desplazarse hacia abajo",
            "description": "Prueba a decir \"Desplazarse hacia abajo\". Esto hará que la página web se desplace hacia abajo."
        },
        "scrollUp": {
            "title": "Desplazarse hacia arriba",
            "description": "Prueba a decir \"Desplazarse hacia arriba\". Esto hará que la página web se desplace hacia arriba."
        },
        "newTab": {
            "title": "Abrir una nueva pestaña",
            "description": "Prueba a decir \"Nueva pestaña\". Se abrirá una nueva pestaña en tu navegador."
        },
        "formsCustomization": {
            "title": "Personalización del llenado de formularios",
            "description": "Puedes personalizar este control de la aplicación para rellenar formularios fácilmente, como nombre, apellido, correo electrónico, etc. Luego, puedes usar Acciones Rápidas o Comandos de Voz para completarlos aún más rápido."
        },
        "complete": {
            "title": "¡Buen trabajo!",
            "description": "Ya sabes usar comandos de voz y acciones rápidas para navegar, buscar, desplazarte y rellenar formularios mientras navegas por la web. Explora más comandos o personaliza tus propias acciones rápidas para una navegación web aún más fluida."
        }
    },
    "spreadsheetReviews": {
        "tourLabel": "Trabaje más rápido en hojas de cálculo con controles de voz",
        "learn": "Aprenda a utilizar comandos de voz y acciones rápidas para revisar y editar hojas de cálculo grandes rápidamente.",
        "tryOpen": {
            "title": "Prueba a decir «Abrir Excel» o «Abrir Hojas de cálculo de Google».",
            "description": "Asegúrate de que tu micrófono esté activado y di \"Abrir Excel\" o \"Abrir Hojas de Cálculo de Google\". Esto abrirá la aplicación de hoja de cálculo que hayas elegido. Si tienes activado el cambio automático de controles, también se cambiará a los controles que mejor se adapten a la aplicación que estés usando."
        },
        "selectRow": {
            "title": "Seleccionar una fila",
            "description": "Haz clic en una celda. Luego, prueba a decir \"Seleccionar fila\". Esto seleccionará toda la fila de la celda seleccionada."
        },
        "delete": {
            "title": "Eliminar el contenido de una fila",
            "description": "Prueba a decir \"Eliminar\". Esto eliminará el contenido de la fila seleccionada."
        },
        "note": {
            "title": "Agregar una nota a una celda",
            "description": "Haz clic en una celda. Luego, prueba a decir \"Agregar nota\". Esto te permitirá agregar una nota a la celda seleccionada."
        },
        "addNote": {
            "title": "Escribe la nota",
            "description": "Prueba a decir \"Escribe. Estos números no coinciden\". Esto escribirá tu nota en la celda."
        },
        "currentDate": {
            "title": "Introduzca la fecha actual",
            "description": "Haz clic en una celda. Luego, prueba a decir \"Fecha actual\". Esto introducirá la fecha actual en la celda seleccionada."
        },
        "copy": {
            "title": "Copiar una celda",
            "description": "Haz clic en la celda donde acabas de añadir la fecha actual. Luego, prueba a decir \"Copiar\". Esto copiará la fecha actual."
        },
        "selectColumn": {
            "title": "Seleccionar una columna",
            "description": "Prueba a decir \"Columna\". Esto seleccionará toda la columna de la celda seleccionada."
        },
        "paste": {
            "title": "Pegar fecha actual",
            "description": "Prueba a decir \"Pegar\". Esto pegará la fecha actual en la columna seleccionada."
        },
        "quickActions": {
            "title": "Utilice acciones rápidas",
            "description": "También puedes usar muchos de estos controles y más con los botones de acción rápida. Puedes personalizarlos para que se adapten a tu flujo de trabajo y agilicen aún más la revisión y edición de hojas de cálculo."
        },
        "complete": {
            "description": "Ya sabes usar comandos de voz y acciones rápidas para revisar y editar hojas de cálculo grandes rápidamente. Explora más comandos o personaliza tus propias acciones rápidas para gestionar tus hojas de cálculo más rápidamente."
        }
    },
    "socialMediaWriting": {
        "tourLabel": "Cree, repita y publique contenido en redes sociales con voz e IA en el dispositivo",
        "learn": "Aprenda a utilizar Generate and Rewrite inteligente, de forma totalmente privada y en el dispositivo, para crear e iterar contenido.",
        "onDeviceIntro": {
            "title": "Su investigación se mantiene privada y segura",
            "description": "Las Tareas Inteligentes de Cephable se basan en la IA del dispositivo, lo que significa que tus datos se mantienen privados y seguros. Puedes crear, reescribir y traducir texto sin necesidad de procesamiento en la nube. También puedes usar contexto entre aplicaciones e iterar ideas directamente en tu aplicación preferida."
        },
        "enterPrompt": {
            "title": "Empieza a idear",
            "description": "En el cuadro de entrada, escriba una propuesta para el contenido que desea estructurar o generar. Por ejemplo, puede escribir: \"Enumerar los riesgos de la IA Agentic, dónde se encuentran algunas de las deficiencias y cómo la innovación puede avanzar\"."
        },
        "customizeSettings": {
            "title": "Personalizar la configuración de generación",
            "description": "Puedes personalizar la configuración de generación según tus preferencias. Ajústala con indicaciones del sistema que reflejan el tono, la imagen de la marca y más."
        },
        "rewriteIntro": {
            "title": "Iterar sobre el contenido",
            "description": "Puedes usar Cephable Intelligent Rewrite para iterar el contenido directamente en tu aplicación preferida. Todo esto se realiza en el dispositivo, lo que significa que tus datos se mantienen privados y seguros."
        },
        "highlightText": {
            "title": "Resaltar texto para reescribir",
            "description": "Resalte uno de los riesgos enumerados del contenido generado que desea desarrollar más a fondo."
        },
        "enterInstructions": {
            "title": "Introduzca instrucciones de reescritura",
            "description": "Escriba las instrucciones de reescritura. Por ejemplo, puede escribir: \"Agregue más detalles sobre los riesgos\"."
        },
        "writeSocialMediaPost": {
            "title": "Escribe una publicación en las redes sociales",
            "description": "Utilice la reescritura nuevamente para reformatear este lenguaje y convertirlo en una publicación pública en las redes sociales que obtenga los puntos clave y destaque las áreas de participación."
        },
        "highlightPost": {
            "title": "Resaltar la publicación generada",
            "description": "Resalte la publicación de redes sociales generada que desea utilizar."
        },
        "enterPostInstructions": {
            "title": "Introducir instrucciones de publicación",
            "description": "Escribe las instrucciones para tu publicación. Por ejemplo, puedes escribir: \"Que sea concisa y atractiva para LinkedIn\"."
        },
        "complete": {
            "description": "Ahora puedes abrir tu plataforma de redes sociales preferida, centrarte en el cuadro de texto de creación de la publicación y pegar la publicación generada. ¡O continúa iterando y refinando hasta que estés listo!"
        }
    },
    "inboxTriage": {
        "tourLabel": "Gestión eficiente del correo electrónico con voz e inteligencia artificial en el dispositivo",
        "learn": "Aprenda a utilizar comandos de voz y tareas inteligentes para administrar su bandeja de entrada de manera eficiente y mantener sus datos seguros.",
        "tryOpen": {
            "title": "Prueba a decir «Abrir Outlook» o «Abrir Gmail».",
            "description": "Asegúrate de que tu micrófono esté activado y di \"Abrir Outlook\" o \"Abrir Gmail\". Esto abrirá la aplicación de correo electrónico que hayas elegido. Si tienes activado el cambio automático de controles, también se cambiará a los controles de la aplicación que mejor se adapten a la que estés usando."
        },
        "select": {
            "title": "Seleccione un correo electrónico",
            "description": "Haz clic en un correo electrónico. Luego, prueba a decir \"Seleccionar correo electrónico\". Esto seleccionará el correo electrónico seleccionado."
        },
        "delete": {
            "title": "Eliminar un correo electrónico",
            "description": "Prueba a decir \"Eliminar\". Esto eliminará el correo electrónico seleccionado."
        },
        "reply": {
            "title": "Responder a un correo electrónico",
            "description": "Haz clic en un correo electrónico. Luego, prueba a decir \"Responder\". Esto abrirá la ventana de respuesta del correo electrónico seleccionado."
        },
        "dictateIntro": {
            "title": "Dicte su respuesta",
            "description": "Puedes usar el dictado para escribir tu respuesta sin usar las manos. Asegúrate de que el micrófono esté encendido y el modo de dictado activado."
        },
        "dictateReply": {
            "title": "Empezar a responder",
            "description": "Intenta decir: \"Me interesa saber más sobre sus servicios. Por favor, envíenme información adicional\". Esto escribirá tu respuesta en el correo electrónico. Asegúrate de centrarte en el cuadro de respuesta."
        },
        "newEmail": {
            "title": "Crear un nuevo correo electrónico",
            "description": "Prueba a decir \"Nuevo correo\". Se abrirá una nueva ventana para redactar el correo."
        },
        "customEmailTemplates": {
            "title": "Plantillas de correo electrónico personalizadas",
            "description": "Puedes crear plantillas de correo electrónico personalizadas para respuestas comunes. Esto te permitirá insertar rápidamente contenido preescrito en tus correos electrónicos mediante comandos de voz o acciones rápidas."
        },
        "editAppControls": {
            "title": "Editar controles de la aplicación",
            "description": "Para crear una plantilla de correo electrónico personalizada, haga clic en el botón Editar controles de la aplicación."
        },
        "addNewControl": {
            "title": "Agregar nuevo control",
            "description": "En el editor de controles de la aplicación, haga clic en el botón Agregar nuevo control."
        },
        "quickAction": {
            "title": "Seleccionar Acción Rápida",
            "description": "Elija Acción rápida como tipo de control."
        },
        "templateName": {
            "title": "Nombra tu plantilla",
            "description": "Dale un nombre a tu plantilla de correo electrónico personalizada, como por ejemplo \"Solicitud de reunión\"."
        },
        "eventType": {
            "title": "Seleccionar el tipo de evento",
            "description": "En la sección de tipo de evento, elija un tipo de evento de \"tipo\"."
        },
        "typeSteps": {
            "title": "Tipo de contenido de plantilla",
            "description": "Escribe el contenido de tu plantilla de correo electrónico. Por ejemplo, puedes escribir: \"Lead Outreach\nHola, me gustaría programar una reunión para hablar sobre posibles oportunidades de colaboración. Por favor, indícame tu disponibilidad\"."
        },
        "finish": {
            "title": "Terminar de crear la plantilla",
            "description": "Haga clic en el botón Finalizar para completar la creación de su plantilla de correo electrónico personalizada."
        },
        "saveTemplate": {
            "title": "Guarda tu plantilla",
            "description": "Haga clic en el botón Guardar para guardar su plantilla de correo electrónico personalizada."
        },
        "focusApp": {
            "title": "Reenfoca tu aplicación de correo electrónico",
            "description": "Regrese a su aplicación de correo electrónico y asegúrese de estar concentrado en la nueva línea de asunto del correo electrónico."
        },
        "useTemplate": {
            "title": "Utilice su plantilla",
            "description": "Ahora puedes usar tu plantilla de correo electrónico personalizada diciendo su nombre o haciendo clic en el botón Acción rápida."
        },
        "generateIntro": {
            "title": "Generar contenido de correo electrónico",
            "description": "También puedes usar Cephable Intelligent Generate para crear contenido de correo electrónico directamente en tu aplicación. Todo esto se realiza en el dispositivo, lo que significa que tus datos se mantienen privados y seguros."
        },
        "enterPrompt": {
            "title": "Ingresar solicitud de correo electrónico",
            "description": "En el cuadro de aviso, escriba: Escriba un correo electrónico profesional a un cliente potencial presentando nuestros servicios y solicitando una reunión."
        },
        "focusNewEmail": {
            "title": "Concéntrese en el nuevo correo electrónico",
            "description": "Asegúrate de estar concentrado en la nueva ventana de redacción de correo electrónico donde quieres que aparezca el texto generado."
        },
        "translateEmail": {
            "title": "Traducir el contenido del correo electrónico",
            "description": "Puedes usar Cephable Intelligent Translate para traducir el contenido del correo electrónico directamente en tu aplicación. Todo esto se realiza en el dispositivo, lo que significa que tus datos se mantienen privados y seguros."
        },
        "highlightText": {
            "title": "Resaltar el contenido del correo electrónico",
            "description": "Resalte el contenido de un correo electrónico largo que desea traducir."
        },
        "enterLanguage": {
            "title": "Introducir idioma de traducción",
            "description": "Escribe el idioma de la traducción. Por ejemplo, puedes escribir: \"español\"."
        },
        "complete": {
            "description": "Ya sabes cómo usar comandos de voz y Tareas Inteligentes para navegar, responder, dictar, generar y traducir correos electrónicos, manteniendo tus datos seguros. Explora más comandos o personaliza tus acciones rápidas para una gestión de correo electrónico aún más fluida."
        }
    },
    "handsFreeMeeting": {
        "tourLabel": "Controles rápidos de reuniones con manos libres",
        "learn": "Ahorre tiempo y reduzca la fatiga en las reuniones virtuales con controles rápidos de reuniones manos libres",
        "tryOpen": {
            "title": "Prueba a decir «Abrir Zoom» o «Abrir Teams».",
            "description": "Asegúrate de que tu micrófono esté activado y di \"Abrir Zoom\" o \"Abrir Teams\". Esto abrirá la aplicación de reuniones que hayas elegido. Si tienes activado el cambio automático de controles, también se cambiará a los controles que mejor se adapten a la aplicación que estés usando."
        },
        "mute": {
            "title": "Prueba a decir «Activar/Desactivar silencio» para silenciar tu micrófono.",
            "description": "Asegúrate de que tu micrófono esté activado y di \"Activar/Desactivar silencio\". Esto silenciará tu micrófono en la aplicación de reuniones seleccionada."
        },
        "video": {
            "title": "Prueba a decir «Activar o desactivar video» para encender o apagar tu cámara.",
            "description": "Asegúrate de que tu micrófono esté activado y di \"Activar/Desactivar video\". Esto activará o desactivará tu cámara en la aplicación de reuniones que hayas elegido."
        },
        "raiseHand": {
            "title": "Intenta decir «Levanta la mano» para levantar la mano.",
            "description": "Asegúrate de que tu micrófono esté activado y di \"Levantar la mano\". Esto hará que levantes la mano en la aplicación de reuniones que hayas elegido."
        },
        "quickType": {
            "title": "Escritura rápida",
            "description": "Asegúrate de que tu micrófono esté activado y di \"Escribe, esta es una función genial\". Esto te permitirá escribir rápidamente con la voz sin estar en modo de dictado. Asegúrate de tener el foco en un campo de texto en la aplicación de reuniones."
        },
        "complete": {
            "description": "Ya sabes cómo usar comandos de voz y acciones rápidas para silenciar/activar el sonido, activar/desactivar el video, levantar la mano y escribir rápidamente en tus aplicaciones de reuniones favoritas. Explora más comandos o personaliza tus propias acciones rápidas para un control de reuniones aún más fluido."
        }
    },
    "summarizingReports": {
        "tourLabel": "Resuma informes y documentos con IA en el dispositivo",
        "learn": "Aprenda a utilizar la generación de resúmenes impulsada por IA para obtener rápidamente los puntos clave de informes y documentos extensos y, al mismo tiempo, mantener seguros sus datos confidenciales y exclusivos.",
        "summarizeIntro": {
            "title": "Resumir texto",
            "description": "Puedes usar las Tareas Inteligentes de Cephable para obtener rápidamente los puntos clave de informes y documentos extensos. Resumir forma parte de las Tareas de IA en el dispositivo, lo que significa que funciona sin conexión a internet y se ejecuta desde tu dispositivo."
        },
        "navigateToReport": {
            "title": "Concéntrese en su informe o documento",
            "description": "Abra su informe o documento en su aplicación preferida y concéntrese en el texto que desea resumir."
        },
        "highlightText": {
            "title": "Resaltar texto para resumir",
            "description": "Resalte el texto que desea resumir."
        },
        "copyText": {
            "title": "Copiar el texto",
            "description": "Después de resaltar el texto, cópialo para prepararlo para el resumen."
        },
        "enterPrompt": {
            "title": "Introducir instrucciones de resumen",
            "description": "Escribe las instrucciones para tu resumen. Indica la longitud, el estilo o cualquier contenido específico que desees."
        },
        "pasteText": {
            "title": "Pegue el contenido de su informe",
            "description": "Después de las instrucciones, pegue el texto copiado en el cuadro de entrada."
        },
        "focusChatApp": {
            "title": "Concéntrese en su aplicación de chat",
            "description": "Abra su aplicación de chat como Teams o Slack y concéntrese en el cuadro de texto donde desea que aparezca el texto resumido."
        },
        "rewriteIntro": {
            "title": "Reescribir texto resumido",
            "description": "También puede usar Cephable Intelligent Rewrite para refinar aún más el texto resumido. Todo esto se realiza en el dispositivo, lo que significa que sus datos se mantienen privados y seguros."
        },
        "highlightSummary": {
            "title": "Resaltar el texto resumido",
            "description": "Resalte el texto resumido que desea refinar más."
        },
        "enterRewriteInstructions": {
            "title": "Introduzca instrucciones de reescritura",
            "description": "Escribe las instrucciones de reescritura. Indica el tono, el estilo o cualquier cambio específico que desees."
        },
        "complete": {
            "description": "Aprendió a usar Tareas Inteligentes para resumir textos de forma rápida y segura y compartir hallazgos con su equipo. Continúe explorando más casos de uso con Resumir y Reescribir, u otras funciones, para optimizar su flujo de trabajo."
        }
    },
    "congrats": "¡Felicitaciones!",
    "noteTakingAndDocumentation": {
        "tourLabel": "Toma de notas y generación de documentos mediante IA privada en el dispositivo",
        "learn": "Aprenda a usar comandos de voz, dictado inteligente y tareas de IA para pasar de notas a diseños y documentos más rápido.",
        "focus": {
            "title": "Centrarse en un campo de texto o documento",
            "description": "El dictado funciona mejor cuando te centras en un campo de texto o documento. Abre un documento o haz clic en el campo de texto donde quieras tomar notas."
        },
        "speaking": {
            "title": "Empieza a hablar",
            "description": "Ahora puedes empezar a hablar. Mientras reflexionas sobre tu idea, habla con naturalidad y deja que tus pensamientos fluyan. Todo lo que digas se escribirá en el campo de texto o documento en el que te centraste. Intenta describir tu concepto, detallar los pasos o generar ideas libremente. Por ejemplo, di: \"Estoy considerando un nuevo flujo de trabajo para nuestro equipo. Primero, deberíamos automatizar el proceso de informes y luego revisar los resultados semanalmente\". Asegúrate de que el cursor esté enfocado en el documento."
        },
        "typeEnter": {
            "title": "Saltos de párrafo",
            "description": "Para crear saltos de párrafo, simplemente pulsa Intro. Esto te ayudará a organizar tus notas en secciones claras. Continúa expresando tus ideas o transcribiendo lo que dice otra persona."
        },
        "rewriteIntro": {
            "title": "Crear diseños",
            "description": "Ahora puedes usar Cephable Intelligent Rewrite para tomar tus notas y diseñarlas para crear una idea o para realizar seguimientos. Todo esto se realiza en el dispositivo, lo que significa que tus datos se mantienen privados y seguros."
        },
        "highlightText": {
            "title": "Resaltar las notas",
            "description": "Seleccione todas las notas que desee utilizar para crear un diseño o documento."
        },
        "inPlaceReplacement": {
            "title": "Ideación en el lugar",
            "description": "Ahora, usaremos el reemplazo en contexto para convertir tus notas en un diseño o documento. Siempre puedes usar el modo pegar o la opción para crear un nuevo archivo."
        },
        "enterInstructions": {
            "title": "Introducir instrucciones de diseño",
            "description": "Puedes escribir las instrucciones de los próximos pasos sobre lo que quieres hacer con las notas. Esto podría ser formato, diseño, tareas de seguimiento o cualquier otra cosa. (Por ejemplo, crea un documento de diseño que destaque cómo funcionaría la función, cómo se ve el proceso completo y cómo se vería el éxito)."
        },
        "complete": {
            "description": "Aprendió a usar comandos de voz y dictado inteligente para documentar notas clínicas, y la reescritura inteligente para formatearlas en estilo SOAP. Continúe explorando más casos de uso con dictado y reescritura, u otras funciones, para optimizar su flujo de trabajo."
        }
    },
    "fpsGamePlay": {
        "tourLabel": "Juega juegos FPS con controles de voz",
        "learn": "Aprende a usar controles de voz y acciones rápidas para jugar juegos FPS.",
        "changeProfile": {
            "title": "Perfil de control de cambios",
            "description": "Cambia el control de tu aplicación al perfil de juego FPS. También puedes personalizarlo para el juego específico que quieras jugar. Consulta el video."
        },
        "autoProfileSwitching": {
            "title": "Desactivar el cambio de control automático",
            "description": "Esto mantendrá activo el control de su aplicación actual hasta que cambie de aplicación."
        },
        "tryOpen": {
            "title": "Prueba a decir «Abrir Valorant» o «Abrir Battlefield»."
        },
        "go": {
            "title": "Prueba a decir \"Ve\"",
            "description": "Asegúrate de que tu micrófono esté encendido y di \"Adelante\". Esto hará que tu personaje avance."
        },
        "stop": {
            "title": "Prueba a decir \"Alto\"",
            "description": "Asegúrate de que tu micrófono esté encendido y di \"Detener\". Esto detendrá el movimiento de tu personaje."
        },
        "complete": {
            "description": "Ya sabes cómo usar comandos de voz y acciones rápidas para moverte, detenerte y controlar a tu personaje en juegos FPS. Explora más comandos o personaliza tus propias acciones rápidas para disfrutar de una experiencia de juego aún más fluida y rápida."
        }
    },
    "presentationControls": {
        "tourLabel": "Controlar presentaciones con comandos de voz",
        "learn": "Aprenda a utilizar comandos de voz y acciones rápidas para navegar y controlar sus presentaciones con manos libres.",
        "tryOpen": {
            "title": "Prueba a decir «Abrir PowerPoint» o «Abrir Google Slides»."
        },
        "startPresentation": {
            "title": "Intente decir \"Iniciar presentación\" para comenzar su presentación de diapositivas",
            "description": "Asegúrate de que tu micrófono esté activado y di \"Iniciar presentación\". Esto iniciará tu presentación en la aplicación de presentaciones que hayas elegido."
        },
        "nextSlide": {
            "title": "Intente decir \"Siguiente diapositiva\" para pasar a la siguiente diapositiva",
            "description": "Asegúrate de que tu micrófono esté activado y di \"Siguiente diapositiva\". Esto te llevará a la siguiente diapositiva de tu presentación."
        },
        "previousSlide": {
            "title": "Intente decir \"Diapositiva anterior\" para volver a la diapositiva anterior",
            "description": "Asegúrate de que tu micrófono esté activado y di \"Diapositiva anterior\". Esto te llevará a la diapositiva anterior de tu presentación."
        },
        "escape": {
            "title": "Intente decir «Escape» para salir del modo de presentación",
            "description": "Asegúrate de que tu micrófono esté activado y presiona \"Escape\". Esto cerrará el modo de presentación en la aplicación elegida."
        },
        "complete": {
            "description": "Ahora ya sabes usar comandos de voz y acciones rápidas para iniciar, navegar y salir de presentaciones sin usar las manos. Explora más comandos o personaliza tus propias acciones rápidas para un control aún más fluido de tus presentaciones."
        }
    },
    "editingImages": {
        "tourLabel": "Edición de imágenes más rápida con controles de voz y dictado",
        "learn": "Aprenda a utilizar comandos de voz, acciones rápidas y dictado para mejorar su proceso de edición de imágenes.",
        "tryOpen": {
            "title": "Prueba a decir «Abrir Figma» o «Abrir Photoshop»"
        },
        "selectAll": {
            "title": "Intente decir \"Seleccionar todo\" para seleccionar todos los elementos en el lienzo",
            "description": "Asegúrate de que tu micrófono esté activado y di \"Seleccionar todo\". Esto seleccionará todos los elementos del lienzo en la aplicación de edición de imágenes que hayas elegido. Asegúrate de tener la aplicación enfocada."
        },
        "bold": {
            "title": "Intente decir \"Negrita\" para poner el texto seleccionado en negrita",
            "description": "Asegúrate de que tu micrófono esté activado y di \"Negrita\". Esto activará el texto seleccionado en negrita en la aplicación de edición de imágenes que elijas. Asegúrate de tener el texto seleccionado."
        },
        "copy": {
            "title": "Intente decir \"Copiar\" para copiar el elemento seleccionado",
            "description": "Asegúrate de que tu micrófono esté activado y di \"Copiar\". Esto copiará el elemento seleccionado en la aplicación de edición de imágenes que hayas elegido. Asegúrate de tener un elemento seleccionado."
        },
        "paste": {
            "title": "Intente decir \"Pegar\" para pegar el elemento copiado",
            "description": "Asegúrate de que tu micrófono esté activado y di \"Pegar\". Esto pegará el elemento copiado en la aplicación de edición de imágenes que hayas elegido."
        },
        "delete": {
            "title": "Intente decir \"Eliminar\" para eliminar el elemento seleccionado",
            "description": "Asegúrate de que tu micrófono esté activado y di \"Eliminar\". Esto eliminará el elemento seleccionado en la aplicación de edición de imágenes elegida. Asegúrate de tener un elemento seleccionado."
        },
        "dictationIntro": {
            "title": "Dictado",
            "description": "Puedes usar el dictado para escribir texto con la voz. Asegúrate de que el micrófono esté encendido y el modo de dictado activado."
        },
        "focus": {
            "title": "Centrarse en un campo de texto",
            "description": "Haga clic en un campo de texto en su aplicación de edición de imágenes donde desee utilizar el dictado."
        },
        "speaking": {
            "title": "Empieza a hablar",
            "description": "Intenta decir: \"Para obtener códigos de descuento anticipados, escanea el código QR. Válido hasta el 30 de septiembre. Después, solicítalo a través del sitio web\". Asegúrate de enfocar el campo de texto o el área donde quieres dictar."
        },
        "complete": {
            "description": "Ahora sabes cómo usar comandos de voz, acciones rápidas y dictado para optimizar tu edición de imágenes. Explora más comandos o personaliza tus propias acciones rápidas para una edición aún más fluida."
        }
    },
    "redo": "Rehacer la incorporación",
    "title": "Conoce a Cephable",
    "description": "Conozca Cephable, su asistente personal de IA y comparta su interés en casos de uso personalizados.",
    "panel": {
        "description": "Este es el panel, el centro de control principal. Siempre está visible y te permite controlar tus aplicaciones con la voz, entre otras funciones. Empecemos por el micrófono."
    }
}
